import { render, staticRenderFns } from "./xmList.vue?vue&type=template&id=3e90f4dc&scoped=true&"
import script from "./xmList.vue?vue&type=script&lang=js&"
export * from "./xmList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e90f4dc",
  null
  
)

export default component.exports